import Carousel from './carouselContainer';

export default Carousel;